import { useEffect, useState, type CSSProperties } from 'react';

/** Keeps a fixed conversation frame above the on-screen keyboard. Shared with IM. */
export function useVisualViewport(enabled = true): CSSProperties | undefined {
  const [style, setStyle] = useState<CSSProperties | undefined>();
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport || !enabled) { setStyle(undefined); return; }
    const update = () => {
      const covered = window.innerHeight - viewport.height > 80;
      setStyle(covered ? { top: `${viewport.offsetTop}px`, bottom: 'auto', height: `${viewport.height}px` } : undefined);
    };
    update(); viewport.addEventListener('resize', update); viewport.addEventListener('scroll', update);
    return () => { viewport.removeEventListener('resize', update); viewport.removeEventListener('scroll', update); };
  }, [enabled]);
  return style;
}
